import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";

export const findAllPalish = createAsyncThunk(
  "Palish/FindAllPalish",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Palish/FindAllPalish`,
        formData
      );

      return response.data.Data;
    } catch (error: any) {
      console.error("Error Fetching Palish", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createPalish = createAsyncThunk(
  "Palish/InsertPalish",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Palish/InsertPalish`,
        formdata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Create Palish:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updatePalish = createAsyncThunk(
  "Palish/UpdatePalish",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Palish/UpdatePalish`,
        formdata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Update Palish:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deletePalish = createAsyncThunk(
  "Palish/DeletePalish",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Palish/DeletePalish`,
        { palish_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Deleting Ghat:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getPalishById = createAsyncThunk(
  "Palish/FindByIDPalish",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Palish/FindByIDPalish`,
        { palish_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        id: result.id,
        palish_guid: result.palish_guid,
        palish_no: result.palish_no,
        issue_date: result.issue_date ? moment(result.issue_date).toDate() : "",
        approx_delivery_date: result.approx_delivery_date
          ? moment(result.approx_delivery_date).toDate()
          : "",
        karigar_id: result.karigar_id,
        karigar_name: result.karigar_name,
        address: result.address,
        karigar_nick_name: result.karigar_nick_name,
        palish_order: result?.palish_order,
        karigarIdWiseOutStandingAmount: result?.karigarIdWiseOutStandingAmount,
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Palish:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deletePalishOrderItems = createAsyncThunk(
  "Palish/DeletePalishOrder",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Palish/DeletePalishOrder`,
        { id: ID }
      );
      SuccessToast(response?.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Palish Order item:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updatePalishImage = createAsyncThunk(
  "Palish/PalishImageUpdate",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Palish/PalishImageUpdate`,
        formdata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Update Palish Image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const FetchWeight = createAsyncThunk(
  "PalishReceipt/FindByPreviousProcessWiseOrderData",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PalishReceipt/FindByPreviousProcessWiseOrderData`,
        formdata
      );
      // SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Update Palish:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
